import React, {useCallback} from 'react';
import {useColorThemeType, useFontTheme} from '@buncha/appStyles/hooks/theme';

import {Analytics} from '@buncha/config/analytics/analytics';
import {B2BUserScreens} from '@buncha/B2B/navigation/types';
import Call from '@buncha/components/core/icon/Call';
import {EventType} from '@buncha/config/analytics/type';
import {H6Text} from '@buncha/components/core/text';
import {HBox} from '@buncha/components/core/view';
import {Linking} from 'react-native';
import {Modules} from '@buncha/utils/types';
import {Touchable} from '@buncha/components/core/touchable';
import {styles} from './styles';
import {useGetLocale} from '@buncha/localization/hooks';

interface ContactShopperButtonProps {
  id: string | number;
  name: string;
  phoneNumber?: string;
  isShopper: boolean;
}

const ContactShopperButton: React.FC<ContactShopperButtonProps> = props => {
  const {id, name, phoneNumber, isShopper} = props;
  const theme = useColorThemeType();
  const muliFont = useFontTheme();
  const {body} =
    useGetLocale(Modules.B2BUserOrder, B2BUserScreens.ShopperInfo) ?? {};

  const callHandler = useCallback(() => {
    Analytics.eventWithProps('Contact your Shopper', {
      type: EventType.cta,
      id,
      name,
      phone: phoneNumber,
    });
    Linking.openURL(`tel:+${phoneNumber}`);
  }, [id, name, phoneNumber]);

  return (
    <Touchable onPress={callHandler}>
      <HBox
        style={[
          styles.container,
          {backgroundColor: theme?.background.blue[100]},
        ]}>
        <Call
          width={25}
          height={25}
          viewBox="0 0 25 20"
          fill={theme?.icon?.white?.[100]}
          style={styles.icon}
        />
        <H6Text
          style={[
            styles.text,
            {color: theme?.text.white[100], fontFamily: muliFont[700].normal},
          ]}>
          {body?.contactYour}
          {isShopper ? body?.shopper : body?.driver}
        </H6Text>
      </HBox>
    </Touchable>
  );
};

export default React.memo(ContactShopperButton);
